import Home from 'pages/Home';
const routes = [...Home];
const privateRoutes = [...Home];
export { routes, privateRoutes };
